import { notification } from "antd";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const TOKEN = localStorage.getItem("token");

export const GETPaginate = async (api, data, setPage = null) => {
  const response = [];
  await axios
    .get(`${API_URL}${api}`, {
      headers: {
        Authorization: TOKEN,
      },
      params: data,
    })
    .then((res) => {
      setPage(
        (prev) =>
          (res.data.datos.last_page > res.data.datos.current_page ? res.data.datos.current_page + 1 : res.data.datos.last_page)
      );
      response.push(res.data.datos.data);
    })
    .catch((error) => {
      if (error.response.status == 401) {
        localStorage.clear();
        window.history.pushState({}, "", "/login");
        window.location.reload();
      }
    });
  return response[0];
};

export const GET = async (api, data = "") => {
  const response = [];
  await axios
    .get(`${API_URL}${api}${data}`, {
      headers: {
        Authorization: TOKEN,
      },
    })
    .then((res) => {
      response.push(res.data.datos);
    })
    .catch((error) => {
      if (error.response.status == 401) {
        localStorage.clear();
        window.history.pushState({}, "", "/login");
        window.location.reload();
      }
      if (error.response && error.response.data.mensaje) {
        notification["error"]({ message: error.response.data.mensaje });
      }
    });
  return response[0];
};

export const POST = async (data, api) => {
  return await axios
    .post(
      `${API_URL}${api}`,
      data,
      {
        headers: {
          Authorization: TOKEN,
        },
      },

    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        localStorage.clear();
        window.history.pushState({}, "", "/login");
        window.location.reload();
      } 
      throw error;
    });
};

export const POSTwithoutToken = async (data, api) => {
  const response = [];
  await axios.post(`${API_URL}${api}`, data).then((res) => {
    response.push(res.data);
  })
    .catch((error) => {
      if (error.response.status == 401) {
        notification.error({
          message: "Ocurrió un error :c",
          description: 'Credenciales incorrectas',
        });
      }

      throw error.response;
    });
  return response[0];
};

export const DELETE = async (api) => {
  return await axios
    .delete(
      `${API_URL}${api}`,
      {
        headers: {
          Authorization: TOKEN,
        },
      }
    )
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        localStorage.clear();
        window.history.pushState({}, "", "/login");
        window.location.reload();
      } 
      throw error;
    });
};
